/** สแกนเครื่อง — รับเฉพาะ payload เต็ม `CAPTAG:1:MACHINE:...` จากเครื่องสแกน (wedge) ไม่รับรหัสที่พิมพ์ */

import { useState } from 'react';

import { parseMachineQr } from '../lib/shopFloor/machineQr';
import { touchTargetStyle } from './touch';

/** เท่ากับเพดาน machine_qr ของเซิร์ฟเวอร์ (1..10) */
export const MAX_SCANNED_MACHINES = 10;

export interface ScannedMachine {
  readonly raw: string;
  readonly machineCode: string;
}

export interface MachineScanPanelProps {
  readonly machines: readonly ScannedMachine[];
  readonly onChange: (machines: readonly ScannedMachine[]) => void;
}

export function MachineScanPanel({ machines, onChange }: MachineScanPanelProps) {
  const [input, setInput] = useState('');
  const [message, setMessage] = useState<string | null>(null);

  const accept = () => {
    const text = input.trim();
    if (text === '') {
      return;
    }
    setInput('');
    const parsed = parseMachineQr(text);
    if (!parsed.ok) {
      setMessage(parsed.message);
      return;
    }
    if (machines.some((machine) => machine.raw === parsed.raw)) {
      setMessage(`สแกนเครื่อง ${parsed.machineCode} ไปแล้ว — ไม่เพิ่มซ้ำ`);
      return;
    }
    if (machines.length >= MAX_SCANNED_MACHINES) {
      setMessage(`สแกนได้ไม่เกิน ${MAX_SCANNED_MACHINES} เครื่อง`);
      return;
    }
    setMessage(null);
    onChange([...machines, { raw: parsed.raw, machineCode: parsed.machineCode }]);
  };

  return (
    <div className="cap-machine-scan" data-testid="scan-in-machines">
      <label className="cap-scan-field">
        <span className="cap-scan-field__label">สแกนเครื่อง</span>
        <input
          className="cap-scan-field__input"
          style={touchTargetStyle}
          type="text"
          inputMode="none"
          name="machine_qr"
          data-testid="scan-in-machine-input"
          value={input}
          autoComplete="off"
          placeholder="สแกน QR ที่เครื่อง"
          onChange={(event) => {
            setInput(event.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              accept();
            }
          }}
        />
        <span className="cap-scan-field__hint">
          สแกนทุกเครื่องที่ใช้ในรอบนี้ — พิมพ์รหัสเครื่องเองไม่ได้ ต้องสแกน QR ที่เครื่อง
        </span>
      </label>

      {message === null ? null : (
        <p className="cap-scan-form__alert" role="alert" data-testid="scan-in-machine-message">
          {message}
        </p>
      )}

      <ul className="cap-machine-scan__chips" data-testid="scan-in-machine-chips">
        {machines.map((machine) => (
          <li key={machine.raw} className="cap-machine-scan__chip" data-testid="scan-in-machine-chip">
            <strong>{machine.machineCode}</strong>
            <button
              type="button"
              style={touchTargetStyle}
              aria-label={`เอาเครื่อง ${machine.machineCode} ออก`}
              data-testid="scan-in-machine-remove"
              onClick={() => {
                onChange(machines.filter((one) => one.raw !== machine.raw));
                setMessage(null);
              }}
            >
              ✕
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
